export enum RouteName {
  List = 'settlements-list',
}
